import { render, staticRenderFns } from "./tab-base-styles.vue?vue&type=template&id=20b50040&scoped=true"
import script from "./tab-base-styles.vue?vue&type=script&lang=js"
export * from "./tab-base-styles.vue?vue&type=script&lang=js"
import style0 from "./tab-base-styles.vue?vue&type=style&index=0&id=20b50040&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b50040",
  null
  
)

export default component.exports